<template>
  <div class="col-lg-12 col-md-6">
    <div :class="`box box-${type} box-solid collapsed-box`">
      <div class="box-header no-border">
        <h3 class="box-title">Click & Collect</h3>
        <div class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
        </div>
      </div>
      <div :class="`info-box bg-${type}-active no-margin`">
        <span class="info-box-icon"><i :class="['fa', icon]"></i></span>
        <div class="info-box-content">
          <span class="info-box-text">
            {{items.sold}}
            davon verkauft ({{items.rate | currency('%')}})
          </span>
          <span class="info-box-number">
            {{items.total}}
            <small> Click and collect</small>
          </span>
        </div>
      </div>
      <div class="box-body" style="display: none;">
        <ul class="list-group list-group-unbordered">
          <li class="list-group-item">
            <b>{{'month' | translate}}:</b> <span class="pull-right">{{items.month}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'last_month' | translate}}:</b> <span class="pull-right">{{items.last_month}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'last_week' | translate}}:</b> <span class="pull-right">{{items.week}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'yesterday' | translate | capitalize}}:</b> <span class="pull-right">{{items.yesterday}}</span>
          </li>
          <li class="list-group-item">
            <b>{{'today' | translate | capitalize}}:</b> <span class="pull-right">{{items.today}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['items', 'type', 'title', 'icon', 'bootstrapClass'],
    data () {
      return {
       timeSelector: this.title === 'returns' ? '30_days' : '7_days'
      }
    },
    methods: {
      getIcon (status) {
        switch (status) {
          case 'warning':
            return ['fa', 'fa-warning', 'mr-5']
          case 'success':
            return ['fa', 'fa-check', 'mr-5']
          case 'danger':
            return ['fa', 'fa-bolt', 'mr-5']
        }
      }
    },
    mounted () {
    },
    watch: {
     items () {
    },
  timeSelector () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/ClickAndCollectBox.vue